export class UserInfoElement {
  UserID: string;
  UserFullName: string;
  OrderMaster_Id: string;
}

export class UserInfoState {
  info: UserInfoElement;
  cartInfo: any;
}
